import { lazy } from 'react';

const OverviewPage = lazy(() => import('../pages/Overview.page'));
const CompaniesDirectoryPage = lazy(() => import('../pages/CompaniesDirectory.page'));
const CompanyDetailPage = lazy(() => import('../pages/CompanyDetail.page'));
const RegistrationsQueuePage = lazy(() => import('../pages/RegistrationsQueue.page'));
const SubscriptionsManagePage = lazy(() => import('../pages/SubscriptionsManage.page'));
const CompanyUsersPage = lazy(() => import('../pages/CompanyUsers.page'));
const LaunchAuditPage = lazy(() => import('../pages/LaunchAudit.page'));
const RolesPermissionsPage = lazy(() => import('../pages/RolesPermissions.page'));
const SystemSectionPage = lazy(() => import('../pages/SystemSection.page'));
const SystemIndexRedirect = lazy(() => import('../pages/SystemIndexRedirect'));

export const ControlPlaneRoutes = [
    {
        path: '/control-plane',
        element: <OverviewPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/control-plane/overview',
        element: <OverviewPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/control-plane/companies',
        element: <CompaniesDirectoryPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/control-plane/companies/:product/:externalId',
        element: <CompanyDetailPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/control-plane/registrations',
        element: <RegistrationsQueuePage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/control-plane/subscriptions',
        element: <SubscriptionsManagePage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/control-plane/users',
        element: <CompanyUsersPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/control-plane/launch-audit',
        element: <LaunchAuditPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/control-plane/roles',
        element: <RolesPermissionsPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/control-plane/systems/:product/:section',
        element: <SystemSectionPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/control-plane/systems/:product',
        element: <SystemIndexRedirect />,
        layout: 'default',
        isAuthReq: true,
    },
];
